<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {};
</script>

<style lang="scss">
@import url("assets/css/base.css");
.flex-item {
  @include flex;
}
</style>
